/* eslint-disable @typescript-eslint/no-explicit-any */
import hoistNonReactStatics from 'hoist-non-react-statics'
import { ComponentProps, ComponentType, forwardRef } from 'react'

const overrideOptional = <TComponent extends ComponentType<any>>(
  component: TComponent,
) => {
  let actualComponent = component
  const componentName = getDisplayName(component)

  const OverridableComponent = forwardRef<any, ComponentProps<TComponent>>(
    (props, ref) => {
      const Component = actualComponent as ComponentType<
        ComponentProps<TComponent>
      >

      return <Component {...props} ref={ref} />
    },
  )

  const override = function override<T>(newComp: TComponent & T): void {
    actualComponent = newComp
    OverridableComponent.displayName = `Overridden(${componentName})`
  }

  const OverridableComponentWithStatics = hoistNonReactStatics(
    OverridableComponent as typeof OverridableComponent & {
      override: typeof override
      original: TComponent
    },
    component,
  )

  OverridableComponentWithStatics.displayName = `Overridable(${componentName})`
  OverridableComponentWithStatics.override = override
  OverridableComponentWithStatics.original = component

  return OverridableComponentWithStatics
}

const getDisplayName = (Component: React.ComponentType<any>) =>
  Component.displayName || Component.name || 'Component'

export default overrideOptional
